<template>
    <div class="point-simulate-page">
        <div class="page-body">
            <div class="left-tree">
                <div class="tree-toolbar">
                    <span>档案树</span>
                    <i class="el-icon-search" @click="showSearchBox = !showSearchBox"></i>
                </div>
                <el-input
                    v-if="showSearchBox"
                    clearable
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
                </el-input>
                <div class="tree-div">
                    <tree
                        type="file"
                        :data="treeData"
                        :currentKey="currentKey"
                        :isDefaultExpandFirst="true"
                        @clickNode="clickNode"
                        ref="trees"
                        v-if="treeData.length">
                    </tree>
                </div>
            </div>
            <div class="main-area">
                <div v-if="!currentPoint" class="empty-tip">
                    请在左侧档案树中选择测点
                </div>
                <div v-else class="config-panel" v-loading="loading">
                    <div class="panel-title">测点信息</div>
                    <el-form label-width="120px" class="config-form">
                        <el-form-item label="测点名称">
                            <span>{{ currentPoint.label }}</span>
                        </el-form-item>
                        <el-form-item label="测点类型" v-if="pointDetail.measure_type">
                            <span>{{ sensorTypeDic[pointDetail.measure_type] || pointDetail.measure_type }}</span>
                        </el-form-item>
                        <el-form-item label="是否开启">
                            <el-switch
                                v-model="form.enable_simulate"
                                active-text="开启"
                                inactive-text="关闭">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="数据时间">
                            <el-date-picker
                                v-model="form.data_time"
                                type="datetime"
                                placeholder="请选择数据时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                :disabled="!form.enable_simulate"
                                clearable>
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading="saving" @click="saveConfig">配置</el-button>
                            <el-button @click="loadConfig">刷新</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tree from '@/components/tree.vue'
import * as device from '@/data/device.js'
import * as pointSimulate from '@/data/pointSimulate.js'
import { sensorTypeDic } from '@/util/sensorType.js'

export default {
    name: 'PointSimulate',
    components: { tree },
    data() {
        return {
            sensorTypeDic,
            treeData: [],
            filterText: '',
            showSearchBox: false,
            currentKey: '',
            currentPoint: null,
            pointDetail: {},
            loading: false,
            saving: false,
            form: {
                enable_simulate: false,
                data_time: ''
            }
        }
    },
    watch: {
        filterText(val) {
            if (this.$refs.trees) {
                this.$refs.trees.filterData(val);
            }
        }
    },
    mounted() {
        this.getTreeData();
    },
    methods: {
        getTreeData() {
            device.queryTree({ add_point: true }).then(res => {
                if (!res) return;
                this.treeData = res.data || [];
            })
        },
        clickNode(node) {
            this.currentKey = node.id;
            if (node.type !== 'point') {
                this.currentPoint = null;
                this.pointDetail = {};
                this.resetForm();
                return;
            }
            this.currentPoint = node;
            this.loadConfig();
        },
        resetForm() {
            this.form = {
                enable_simulate: false,
                data_time: ''
            };
        },
        loadConfig() {
            if (!this.currentPoint) return;
            this.loading = true;
            pointSimulate.getPointSimulate({ point_id: this.currentPoint.id }).then(res => {
                const data = res.data || {};
                this.pointDetail = data;
                this.form.enable_simulate = !!data.enable_simulate_data;
                this.form.data_time = data.simulate_data_time || '';
            }).catch(() => {
                this.resetForm();
                this.pointDetail = {};
            }).finally(() => {
                this.loading = false;
            });
        },
        saveConfig() {
            if (!this.currentPoint) {
                this.$message.warning('请先选择测点');
                return;
            }
            if (this.form.enable_simulate && !this.form.data_time) {
                this.$message.warning('开启数据时请填写数据时间');
                return;
            }
            this.saving = true;
            pointSimulate.updatePointSimulate({
                point_id: this.currentPoint.id,
                data: {
                    enable_simulate: this.form.enable_simulate,
                    data_time: this.form.data_time || ''
                }
            }).then(res => {
                const data = res.data || {};
                this.pointDetail = data;
                this.form.enable_simulate = !!data.enable_simulate_data;
                this.form.data_time = data.simulate_data_time || '';
                this.$message.success('配置成功');
            }).catch(err => {
                this.$message.error(typeof err === 'string' ? err : '配置失败');
            }).finally(() => {
                this.saving = false;
            });
        }
    }
}
</script>

<style lang="less" scoped>
.point-simulate-page {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #212325;
    color: #fff;
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    background: #17191A;
    border-bottom: 1px solid #444648;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
}

.page-tip {
    font-size: 13px;
    color: #999;
}

.page-body {
    flex: 1;
    display: flex;
    min-height: 0;
}

.left-tree {
    width: 280px;
    height: 100%;
    background: #2C2F32;
    border-right: 1px solid #444648;
    display: flex;
    flex-direction: column;
}

.tree-toolbar {
    background: #4A4C4F;
    padding: 10px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tree-div {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.main-area {
    flex: 1;
    padding: 24px;
    overflow: auto;
}

.empty-tip {
    color: #999;
    font-size: 14px;
    margin-top: 80px;
    text-align: center;
}

.config-panel {
    max-width: 640px;
}

.panel-title {
    font-size: 16px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #444648;
}

.config-form {
    /deep/ .el-form-item__label {
        color: #ccc;
    }

    /deep/ .el-form-item__content {
        color: #fff;
    }
}

/deep/ .el-input__inner {
    background: #2C2E30;
    border: 1px solid #444648;
    color: #fff;
}

/deep/ .el-date-editor {
    background: #2C2E30;
    border: 1px solid #444648;
    width: 320px;
}

/deep/ .el-tree {
    background: #2C2F32;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/internal/pointSimulate.vue